/* eslint-disable */
import React, { memo, useMemo } from 'react'
import { MeshReflectorMaterial } from '@react-three/drei'
import { Bounds } from '../../../models/Types'

const Floor: React.FC<{ bounds: Bounds }> = memo(({ bounds }) => {
  const floorGeometry = useMemo(() => (
    <planeGeometry args={[bounds.max.x - bounds.min.x, bounds.max.z - bounds.min.z]} />
  ), [bounds]);

  const floorMaterial = useMemo(() => (
    <MeshReflectorMaterial
      opacity={0.2}
      blur={[300, 300]}
      resolution={2048}
      mixBlur={0.95}
      mixStrength={20}
      roughness={1.9}
      depthScale={1.2}
      minDepthThreshold={0.9}
      maxDepthThreshold={1.0}
      color="#ffffff"
      metalness={0.9}
      mirror={0.7}
    />
  ), []);

  return (
    <>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
        {floorGeometry}
        {floorMaterial}
      </mesh>
    </>
  )
}, (prev, next) => prev.bounds.min.equals(next.bounds.min) && prev.bounds.max.equals(next.bounds.max));

export default Floor;
